module.exports = __webpack_public_path__ + "img/iconDownloadMapNavy.3840f19e.svg";